import React      from 'react';
import BoxContext from '@widesk-ui/contexts/BoxContext';

export function useBox() {
	return React.useContext(BoxContext);
}
